<template>
  <div class="course">
    <!-- 课程列表 -->
    <ActivityGoodsList :span="8" @select="selectActivity">
      <div slot="title">
      </div>
    </ActivityGoodsList>
  </div>
</template>

<script>
import ActivityGoodsList from "@/components/course/ActivityGoodsList";

export default {
  name: "CourseGoods",
  components: {
    ActivityGoodsList
  },
  data() {
    return {};
  },
  methods: {
    selectActivity(item){
      this.$router.push({
        path: `/activity/detail?actId=${item.id}`,
      });
    }
  },
};
</script>

<style land="less" scoped>
.course{
  padding: 20px;
  background: #fff;
}
</style>